let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("loRRx")).then(() => parcelRequire('d6uE7'));